import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'
import './Algorithms.css'
import { Link } from 'react-router-dom'
import { auth, database } from './firebase';
import logo from './images/semicolon.png'

function Ds() {

  const [loggedIn, setLoggedIn] = useState(false);
  const [userQuestions, setUserQuestions] = useState([]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setLoggedIn(true);
        fetchUserQuestions(user.uid);
      } else {
        setLoggedIn(false);
      }
    });

    return unsubscribe()
  }, [auth]);

  const fetchUserQuestions = (userId) => {
    const userRef = database.ref('users').child(userId).child('questions');
    userRef.on('value', (snapshot) => {
      const questionsData = snapshot.val();
      if (questionsData) {
        const questionsArray = Object.values(questionsData);
        setUserQuestions(questionsArray);
      }
    });
  };

  return (
    <div className='algorithms-container'>
        <Navbar />
        <div className='logo-container'>
          <Link to='/'>
          <img src={logo} className='logo' alt='logo' />
          </Link>
        </div>
        <div className='message'>
          <h1>
            SORRY !
          </h1>
          <p>
          Dear mobile user, we know you like convenience, but trust us when we say the desktop experience of this web app will blow your tiny mobile mind. Don't settle for less switch to desktop view and unleash your awesome powers!
          </p>
        </div>
        {loggedIn ? (
        <div className='algo-hide'>
          <div className='algo_tb'>
              <p>Problem</p>
              <p>Difficulty</p>
          </div>
          <div className='prob_diff'>
              <div className='algorithms'>
                  <Link to='/problems/ll-palindrome' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Linked List Palindrome') ? 'submitted' : ''}`}>Linked List Palindrome</p>
                  </Link>
                  <Link to='/problems/stack-min-emt' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Stack Minimum Element') ? 'submitted' : ''}`}>Stack Minimum Element</p>
                  </Link>
                  <Link to='/problems/queue-stacks' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Queue Using Stacks') ? 'submitted' : ''}`}>Queue Using Stacks</p>
                  </Link>
                  <Link to='/problems/bst-valid' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Binary Search Tree Validation') ? 'submitted' : ''}`}>Binary Search Tree Validation</p>
                  </Link>
                  <Link to='/problems/max-dep-bt' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Maximum Depth of Binary Tree') ? 'submitted' : ''}`}>Maximum Depth of Binary Tree</p>
                  </Link>
                  <Link to='/problems/trie-imt' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Trie Implementation') ? 'submitted' : ''}`}>Trie Implementation</p>
                  </Link>
                  <Link to='/problems/sd-bt' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Serialize and Deserialize Binary Tree') ? 'submitted' : ''}`}>Serialize and Deserialize Binary Tree</p>
                  </Link>
                  <Link to='/problems/heap-sort' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Heap Sort') ? 'submitted' : ''}`}>Heap Sort</p>
                  </Link>
                  <Link to='/problems/red-black-tree' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Red-Black Tree Insertion') ? 'submitted' : ''}`}>Red-Black Tree Insertion</p>
                  </Link>
                  <Link to='/problems/b+tree' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'B+ Tree') ? 'submitted' : ''}`}>B+ Tree</p>
                  </Link>
              </div>
              <div className='diff'>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Hard</p>
                  <p>Hard</p>
              </div>
          </div>
        </div>
        ) : (
          <div>
            <h2>Please sign up/login to see this page</h2>
          </div>
        )}
    </div>
  )
}

export default Ds